export enum Education {
  EducationElementarySchool = 'Elementary school',
  EducationVocationalSchool = 'Vocational school',
  EducationHighSchool = 'High school',
  EducationHigherEducation = 'Higher education',
}
